import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { useAgreementTriageModal } from '~/components/AgreementTriageModal/AgreementTriageModalOpener';
import { ImportAgreementModal } from '~/components/ImportAgreementModal/ImportAgreementModal';
import { SelectProposalTypeModal } from '~/components/SelectProposalTypeModal/SelectProposalTypeModal';
import { useProposalTemplates } from './reactQuery/queries/useProposalTemplates';
import { useRedirectToProposal } from './useCreateAgreement';
export function useOpenNewProposal() {
    let { navigationState } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { templates, isLoading } = useProposalTemplates({
        refreshOnMount: true
    });
    const { openCreationModal } = useRedirectToProposal();
    const { showModal } = useOverlayContext();
    const { open: openAgreementTriage } = useAgreementTriageModal();
    const hasProposalTemplates = !!(templates === null || templates === void 0 ? void 0 : templates.length);
    function openSelectProposalTypeModal(proposalType) {
        showModal({
            biName: 'select_proposal_type_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            openBottomSheetOnMobile: true,
            hideBottomSheetOnDismiss: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(SelectProposalTypeModal, {
                    dismissModal: dismissModal,
                    proposalType: proposalType,
                    navigationState: navigationState,
                    onImportAgreement: openImportAgreement
                });
            }
        });
    }
    function openImportAgreement() {
        showModal({
            closeOnClickOutside: false,
            closeOnEscapeKey: true,
            openBottomSheetOnMobile: true,
            hideBottomSheetOnDismiss: true,
            biName: 'import_agreement',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ImportAgreementModal, {
                    dismissModal: dismissModal,
                    onSuccess: (extraction, conversationId)=>{
                        dismissModal();
                        openAgreementTriage(conversationId, extraction);
                    }
                });
            }
        });
    }
    async function openNewProposal() {
        if (hasProposalTemplates) {
            openSelectProposalTypeModal();
        } else {
            await openCreationModal({
                state: navigationState
            });
        }
    }
    return {
        isLoadingProposalTemplates: isLoading,
        hasProposalTemplates,
        openNewProposal,
        openSelectProposalTypeModal,
        openImportAgreement
    };
}
